import { Grid } from '@material-ui/core';
import React from 'react'
import { MaskedField, TextField } from '../../Components/Fields';
import { Field, Form } from 'react-final-form';
import TelephoneField from '../../Components/Fields/TelephoneField';
import { emailValido, validateCPF } from '../../utils/utils';
import validatePassword from '../login/validationPassword';

export default (props) => {  

  const { 
    classes, 
    handleSaveReserva, 
    componentConsentimento, 
    componentConfirmarReserva,
    logged,
    initialValues
  } = props;

  const validateFields = values => ({
    nome: !values.nome ? "Campo Obrigatório" : undefined,
    telefone: !values.telefone ? "Campo Obrigatório" : undefined,
    documento: validateCPF(values.documento),
    email: !values.email ? "Campo Obrigatório" : !emailValido(values.email) ? 'Formato inválido' : undefined,
    password: values.criar_conta ? validatePassword(values.password) : undefined,
    password_confirm: values.criar_conta && (values.password !== values.password_confirm) ? "Senhas diferem" : undefined,
  });

  return <>
    <Form
      onSubmit={handleSaveReserva}
      validate={validateFields}
      initialValues={initialValues}
      render={({ handleSubmit, values }) => (
        <form onSubmit={handleSubmit} className={classes.form}>
          <Grid container className={classes.formContainer}>
            <Grid item xs={12} className={classes.fieldContainer}>
              <Field
                name="nome"
                className={classes.field}
                label="Seu nome"
                component={TextField}
              />
            </Grid>
            <Grid item xs={12} className={classes.fieldContainer}>
              <Field
                name="telefone"
                className={classes.field}
                label="Telefone"
                fullWidth
                component={TelephoneField}
              />
            </Grid>
            <Grid item xs={12} className={classes.fieldContainer}>
              <Field
                name="email"
                className={classes.field}
                label="E-mail"
                component={TextField}
                disabled={logged}
              />
            </Grid>
            <Grid item xs={12} className={classes.fieldContainer}>
              <Field
                name="documento"
                className={classes.field}
                label="CPF"
                mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                placeholder="000.000.000-00"
                component={MaskedField}
              />
            </Grid>

            <Grid item xs={12} className={classes.checkBoxContainer}>
              {componentConsentimento}
            </Grid>

            <Grid item xs={12} className={classes.submitContainer}>
              {componentConfirmarReserva}
            </Grid>

          </Grid>
        </form>
      )}
    />
  </>;
}